import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, NgModule } from '@angular/core';

class SeFeFormControlHelpComponent {
}
SeFeFormControlHelpComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormControlHelpComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeFormControlHelpComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeFormControlHelpComponent, selector: "se-fe-form-control-help", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{display:block;color:#68767f;font-family:\"Open Sans\",sans-serif;font-size:calc(var(--se-rem, 1rem) * .8571428571);margin:4px 0 0}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormControlHelpComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-form-control-help',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-form-control-help.component.scss'],
                }]
        }] });

class SeFeFormControlHelpModule {
}
SeFeFormControlHelpModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormControlHelpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeFormControlHelpModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormControlHelpModule, declarations: [SeFeFormControlHelpComponent], imports: [CommonModule], exports: [SeFeFormControlHelpComponent] });
SeFeFormControlHelpModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormControlHelpModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormControlHelpModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeFormControlHelpComponent],
                    imports: [CommonModule],
                    exports: [SeFeFormControlHelpComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeFormControlHelpComponent, SeFeFormControlHelpModule };
